import { portfolioImages } from "../assets/portfolio/portfolio";

export const PortfolioContentConfig = [
  {
    pageName: "rxnt",
    title: "RXNT, USA",
    content:
      "A leader in healthcare technology solutions, RXNT is recognized on the annual Inc. Magazine list of 5000 Fastest-Growing Private Companies 2019, the most prestigious ranking of the nation’s fastest-growing private companies.",
    backgroundImage: portfolioImages.hero.rxnt,
    infoSection: {
      image: portfolioImages.mockup.rxnt,
      alt: "rxntMockupImg",
      paragraphs: [
        <h5 className="text-primary fw-normal">
          As an industry leader,{" "}
          <a
            className="text-primary ft-16 text-decoration-underline"
            href="https://www.rxnt.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            RXNT
          </a>{" "}
          has been pioneering healthcare software since 1999, setting a standard
          of excellence that endures to this day.
        </h5>,
        <h5 className="text-primary fw-normal">
          From its inception, RXNT revolutionized prescription writing with an
          e-prescribing solution that remains the gold standard in the industry.
        </h5>,
        <h5 className="text-primary fw-normal">
          Since then, RXNT has expanded its offerings to encompass a fully
          integrated suite of healthcare software, designed to assist practices
          of all specialties and sizes in managing a wide range of
          administrative tasks.
        </h5>,
        <h5 className="text-primary fw-normal">
          Over the years, RXNT's tools have facilitated the sending of more than
          52 million prescriptions and the processing of an average of $200
          million in claims annually.
        </h5>,
        <h5 className="text-primary fw-normal">
          RXNT's commitment to innovation and reliability has earned it numerous
          awards and certifications for its eRx, EHR, Practice Management, and
          Billing solutions. With cost-effective, cloud-based systems that are
          both fully integrated and user-friendly, RXNT continues to lead the
          industry, providing robust functionality while simplifying
          implementation and usage for physician practices, healthcare
          providers, and medical billing companies alike.
        </h5>,
        <h5 className="text-primary fw-normal">
          Trusted since 1999, RXNT remains at the forefront of healthcare
          technology, delivering solutions that empower providers and enhance
          patient care. They have also been awarded and recognized with numerous
          awards like{" "}
          <a
            className="text-primary ft-16 text-decoration-underline"
            href="https://www.rxnt.com/rxnt-is-a-top-performing-ehr-billing-software-of-2023-voted-by-physicians/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Gartner Report badges
          </a>
          ,{" "}
          <a
            className="text-primary ft-16 text-decoration-underline"
            href="https://www.rxnt.com/gartner-digital-markets-recognizes-rxnts-healthcare-software-as-category-leader-frontrunner-in-2022/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Gartner Digital Markets
          </a>
          ,{" "}
          <a
            className="text-primary ft-16 text-decoration-underline"
            href="https://www.rxnt.com/rxnt-recognized-as-capterra-best-value-2021-for-patient-portal-software/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Capterra Best Patient Portal Software
          </a>
          ,{" "}
          <a
            className="text-primary ft-16 text-decoration-underline"
            href="https://www.inc.com/inc5000"
            target="_blank"
            rel="noopener noreferrer"
          >
            Inc 5000 List Of The “Fastest-Growing Private Companies”
          </a>{" "}
          &{" "}
          <a
            className="text-primary ft-16 text-decoration-underline"
            href="https://www.rxnt.com/rxnt-recognized-as-the-best-e-prescribing-software-2021/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Best E-Prescribing Software
          </a>
          , which reflects how RXNT solutions are accepted worldwide.
        </h5>,
      ],
      insights: {
        title:
          "Acube Technologies helping them to maintain their software leadership.",
        info: [
          <h5 key="insight-1" className="text-primary fw-normal mb-4">
            Acube Technologies has tried to maintain the legacy that RXNT has
            created while also addressing today's changing healthcare
            challenges, we have tried our best to bring creativity and ingenuity
            to the software being developed here at Acube. Some of our best
            software implementations at RXNT are:
          </h5>,
          <ul key="insight-2">
            <li className="text-primary ft-16">
              Our cloud-based solutions - To keep your practice's data secure
              and give you easy access to the information and functions you
              need.
            </li>
            <li className="text-primary ft-16">
              Cross-platform mobile app: With mobile apps for iOS and Android,
              you'll stay connected from anywhere. Our cutting-edge solutions
              have the certifications you expect from your trusted healthcare
              technology solution.
            </li>
            <li className="text-primary ft-16">
              Healthcare Certifications -
              <a
                className="text-primary ft-16 text-decoration-underline"
                href="https://www.rxnt.com/rxnt-recognized-as-capterra-best-value-2021-for-patient-portal-software/"
                target="_blank"
                rel="noopener noreferrer"
              >
                EHR
              </a>{" "}
              is Drummond-certified for ONC-HIT and meets the requirements of
              <a
                className="text-primary ft-16 text-decoration-underline"
                href="https://www.rxnt.com/rxnt-recognized-as-capterra-best-value-2021-for-patient-portal-software/"
                target="_blank"
                rel="noopener noreferrer"
              >
                {" "}
                Electronic Prescribing for Controlled Substances (EPCS)
              </a>
              . Our integrated system also complies with Health Insurance
              Portability and Accountability Act (HIPAA) regulations, so you can
              feel confident in the security of your patients' medical
              information.
            </li>
          </ul>,
        ],
      },
    },
    technologyList: {
      title: "Technologies that drives RXNT",
      image: portfolioImages.technology.rxnt,
      alt: "rxnt-tech",
    },
  },
  {
    pageName: "frank",
    title: "FRANK, Australia",
    content:
      "A company that helps businesses ensure food safety compliance in a simple and straightforward way, now overseeing over 500,000 meals per year in Australia.",
    backgroundImage: portfolioImages.hero.frank,
    infoSection: {
      image: portfolioImages.mockup.frank,
      alt: "frankMockupImg",
      paragraphs: [
        <h5 className="text-primary fw-normal">
          <a
            className="text-primary ft-16 text-decoration-underline"
            href="https://frankfoodsafety.com/home"
            target="_blank"
            rel="noopener noreferrer"
          >
            Frank Food Safety
          </a>{" "}
          stands as a trusted partner for businesses striving to uphold food
          safety standards with efficiency and effectiveness. Their mission
          revolves around simplifying the often intricate landscape of food
          safety compliance, offering practical solutions and guidance that
          businesses can readily implement.
        </h5>,
        <h5 className="text-primary fw-normal">
          By streamlining processes and providing clear directives, they enable
          organizations to navigate regulatory requirements with confidence and
          ease. With their support, businesses across diverse industries can
          ensure the safety and quality of the meals they produce and serve to
          consumers.
        </h5>,
        <h5 className="text-primary fw-normal">
          Their impact is palpable, as they now oversee the compliance of over
          500,000 meals annually in Australia alone, exemplifying their
          dedication to promoting food safety and public health on a{" "}
          <a
            className="text-primary ft-16 text-decoration-underline"
            href="https://www.foodsafetysystems.net.au/frank_app.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            significant scale
          </a>{" "}
          through their{" "}
          <a
            className="text-primary ft-16 text-decoration-underline"
            href="https://apps.apple.com/au/app/frank/id1224589537"
            target="_blank"
            rel="noopener noreferrer"
          >
            app
          </a>
          .
        </h5>,
      ],
      insights: {
        title:
          "How Acube technologies helped FRANK to uphold its food safety standards.",
        info: [
          <h5 key="insight-1" className="text-primary fw-normal mb-4">
            Acube Technologies played a pivotal role in assisting{" "}
            <a
              className="text-primary ft-16 text-decoration-underline"
              href="https://frankfoodsafety.com/home"
              target="_blank"
              rel="noopener noreferrer"
            >
              Frank Food Safety
            </a>{" "}
            in upholding its food safety standards by leveraging a combination
            of NativeScript, Node.JS, and MySQL technologies.
          </h5>,
          <ul key="insight-2">
            <li className="text-primary ft-16">
              Through the utilization of NativeScript, our team developed a
              robust and user-friendly mobile application that enabled FRANK's
              staff to seamlessly manage and monitor food safety protocols on
              the go. This
              <a
                className="text-primary ft-16 text-decoration-underline"
                href="https://apps.apple.com/au/app/frank/id1224589537"
                target="_blank"
                rel="noopener noreferrer"
              >
                {" "}
                native mobile app{" "}
              </a>
              provided an intuitive interface for conducting inspections,
              recording data, and generating reports in real-time, enhancing
              efficiency and accuracy in compliance efforts.
            </li>
            <li className="text-primary ft-16">
              In conjunction with NativeScript, our team implemented Node.JS to
              create a scalable and high-performance backend system. Node.JS
              facilitated seamless communication between the mobile app and the
              database, ensuring rapid data retrieval and processing. This
              real-time synchronization enabled Frank Food Safety to access
              up-to-date information and insights into their food safety
              practices, empowering proactive decision-making and risk
              mitigation.
            </li>
            <li className="text-primary ft-16">
              Behind the scenes, Acube Technologies utilized MySQL as the
              backend database solution, providing a secure and reliable
              repository for storing and managing critical data related to food
              safety compliance. The MySQL database ensured data integrity and
              accessibility, allowing Frank Food Safety to maintain
              comprehensive records and documentation to meet regulatory
              requirements effectively.
            </li>
            <li className="text-primary ft-16">
              <a
                className="text-primary ft-16 text-decoration-underline"
                href="https://frankfoodsafety.com/home"
                target="_blank"
                rel="noopener noreferrer"
              >
                Frank food safety{" "}
              </a>
              stands as a trusted partner for businesses striving to uphold food
              safety standards with efficiency and effectiveness. Their mission
              revolves around simplifying the often intricate landscape of food
              safety compliance, offering practical solutions and guidance that
              businesses can readily implement.
            </li>
          </ul>,
        ],
      },
    },
    technologyList: {
      title: "Technologies that drives Frank food safety",
      image: portfolioImages.technology.frank,
      alt: "frank-tech",
    },
  },
  {
    pageName: "svhs",
    title: "Silicon Valley High School, USA",
    content:
      "Silicon Valley High School offers students enrolled in traditional high schools or homeschooling programs the opportunity to access innovative, relevant, and compelling online high school courses.",
    backgroundImage: portfolioImages.hero.svhs,
    infoSection: {
      image: portfolioImages.mockup.svhs,
      alt: "svhsMockupImg",
      paragraphs: [
        <h5 className="text-primary fw-normal">
          <a
            className="text-primary ft-16 text-decoration-underline"
            href="https://svhs.co/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            Silicon Valley High School{" "}
          </a>
          offers students enrolled in traditional high schools or homeschooling
          programs the opportunity to access innovative, relevant, and{" "}
          <a
            className="text-primary ft-16 text-decoration-underline"
            href="https://svhs.co/high-school-curriculum-for-schools/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            compelling online high school courses
          </a>
          . Whether students aim to jump ahead or catch up on credits for
          graduation, SVHS provides the necessary flexibility and resources for
          success.
        </h5>,
        <h5 className="text-primary fw-normal">
          The entire SVHS community, including students, teaching faculty, and
          administrators, operates in the online space, eliminating the need for
          physical classrooms. Regardless of geographic location, students only
          require a standard web browser and an Internet connection to
          participate in our programs.
        </h5>,
        <h5 className="text-primary fw-normal">
          As an NCAA-approved online school, SVHS takes pride in its track
          record of graduating over 10,000 students to date. With a consistent
          influx of at least 50 new students enrolling daily, SVHS remains
          committed to academic excellence and accessibility.
        </h5>,
        <h5 className="text-primary fw-normal">
          Prospective students are invited to join Silicon Valley High School
          and experience a dynamic
          <a
            className="text-primary ft-16 text-decoration-underline"
            href="https://svhs.co/announcing-ai-platform-online-curriculum/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            online learning environment integrated with artificial intelligence{" "}
          </a>{" "}
          tailored to their educational needs.
        </h5>,
      ],
      insights: {
        title:
          "How Acube technologies have helped Silicon Valley High School to create its dynamic online learning environment",
        info: [
          <h5 key="insight-1" className="text-primary fw-normal mb-4">
            <a
              className="text-primary ft-16 text-decoration-underline"
              href="https://acubetechnologies.in/Home"
              target="_blank"
              rel="noopener noreferrer"
            >
              Acube Technologies
            </a>{" "}
            has been instrumental in enabling Silicon Valley High School (SVHS)
            to establish a dynamic online learning environment by leveraging a
            range of cutting-edge technologies and solutions. Through the
            integration of the{" "}
            <a
              className="text-primary ft-16 text-decoration-underline"
              href="https://www.youtube.com/watch?v=OKz5NrRITg8"
              target="_blank"
              rel="noopener noreferrer"
            >
              Moodle Learning Management
            </a>{" "}
            System (LMS), powered by{" "}
            <a
              className="text-primary ft-16 text-decoration-underline"
              href="https://acubetechnologies.in/services/hire_php_developer"
              target="_blank"
              rel="noopener noreferrer"
            >
              PHP
            </a>{" "}
            and MySQL development, Acube has provided SVHS with a robust
            platform for course management, content delivery, and student
            engagement.
          </h5>,
          <h5 key="insight-2" className="text-primary fw-normal mb-4">
            Additionally, Acube implemented{" "}
            <a
              className="text-primary ft-16 text-decoration-underline"
              href="https://svhs.co/announcing-ai-platform-online-curriculum/"
              target="_blank"
              rel="noopener noreferrer"
            >
              chatbot technology
            </a>{" "}
            to enhance communication and support services, facilitating timely
            assistance for students and faculty. Moreover, Acube collaborated
            with SVHS to{" "}
            <a
              className="text-primary ft-16 text-decoration-underline"
              href="https://www.youtube.com/watch?v=fgRH23FzNKs"
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              implement proctored exam solutions, ensuring the integrity and
              security of remote assessments
            </a>
            .
          </h5>,
          <h5 key="insight-3" className="text-primary fw-normal mb-4">
            Through customized online platform development, Acube has enabled
            SVHS to offer a user-friendly interface, intuitive navigation, and
            seamless integration with educational tools. Overall, Acube
            Technologies' expertise and collaboration have empowered SVHS to
            deliver academic excellence, accessibility, and innovation in its
            online learning initiatives.
          </h5>,
        ],
      },
    },
    technologyList: {
      title: "Technologies that drives SVHS",
      image: portfolioImages.technology.svhs,
      alt: "svhs-tech",
    },
  },
  {
    pageName: "tds",
    title: "Tax Data Systems, USA",
    content:
      "A web-based tax API serving major eCommerce websites since 2009. Joined Thomson Reuters in 2014, and maintain the broadest and deepest coverage of indirect tax content in 14,500 tax jurisdictions for more than 175 countries",
    backgroundImage: portfolioImages.hero.tds,
    infoSection: {
      image: portfolioImages.mockup.tds,
      alt: "tdsMockupImg",
      paragraphs: [
        <h5>
          <a
            className="text-primary ft-16 text-decoration-underline"
            href="https://vikingcoders.com/products/tax-data-systems"
            target="_blank"
            rel="noopener noreferrer"
          >
            Tax Data Systems
          </a>{" "}
          stands as the premier provider of{" "}
          <a
            className="text-primary ft-16 text-decoration-underline"
            href="https://www.salestaxinstitute.com/resources/tax-software"
            target="_blank"
            rel="noopener noreferrer"
          >
            sales tax solutions
          </a>
          , offering a web-based tax API that has served major e-commerce
          websites since its inception in 2009. Since{" "}
          <a
            className="text-primary ft-16 text-decoration-underline"
            href="https://www.thomsonreuters.com/en/press-releases/2014/thomson-reuters-data-and-research-offering-provides-indirect-tax-information.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            joining forces with Thomson Reuters in 2014
          </a>
          ,
          <a
            className="text-primary ft-16 text-decoration-underline"
            href="https://www.cpapracticeadvisor.com/2013/06/28/2013-review-of-thomson-reuters-onesource-indirect-tax-global-software-suite/11824/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Tax Data Systems
          </a>{" "}
          has maintained its position as a leader, boasting the broadest
          coverage of indirect tax content across 14,500 tax jurisdictions
          spanning more than 175 countries.
        </h5>,
        <h5>
          By meticulously tracking tax rates in numerous taxing jurisdictions
          nationwide,{" "}
          <a
            className="text-primary ft-16 text-decoration-underline"
            href="https://www.americommerce.com/Advanced-Tax-Module-by-Tax-Data-Systems"
            target="_blank"
            rel="noopener noreferrer"
          >
            Tax Data Systems
          </a>{" "}
          ensures the provision of the most precise and up-to-date data
          available. Renowned for its extensive experience, unwavering accuracy,
          world-class customer support, and competitive pricing.
        </h5>,
        <h5 className="mb-1">They have top clients like :</h5>,
        <ul>
          <li>
            <a
              className="text-primary ft-16 text-decoration-underline"
              href="https://www.nyse.com/index"
              target="_blank"
              rel="noopener noreferrer"
            >
              New York Stock Exchange
            </a>
          </li>
          <li>
            <a
              className="text-primary ft-16 text-decoration-underline"
              href="https://www.thomsonreuters.com/en.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              Thomson.com
            </a>
          </li>
          <li>
            <a
              className="text-primary ft-16 text-decoration-underline"
              href="https://en.wikipedia.org/wiki/Trump_University"
              target="_blank"
              rel="noopener noreferrer"
            >
              Trump University
            </a>
          </li>
          <li>
            <a
              className="text-primary ft-16 text-decoration-underline"
              href="https://www.xerox.com/en-in"
              target="_blank"
              rel="noopener noreferrer"
            >
              Xerox Corporation
            </a>
          </li>
          <li>
            <a
              className="text-primary ft-16 text-decoration-underline"
              href="https://www.gehealthcare.in/"
              target="_blank"
              rel="noopener noreferrer"
            >
              GE Healthcare
            </a>
          </li>
          <li>
            <a
              className="text-primary ft-16 text-decoration-underline"
              href="https://www.google.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Google
            </a>
          </li>
          <li>
            <a
              className="text-primary ft-16 text-decoration-underline"
              href="https://www.acer.com/in-en/laptops"
              target="_blank"
              rel="noopener noreferrer"
            >
              Acer Computers
            </a>
          </li>
          <li>
            <a
              className="text-primary ft-16 text-decoration-underline"
              href="https://www.disney.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Disney
            </a>
          </li>
          <li>
            <a
              className="text-primary ft-16 text-decoration-underline"
              href="https://www.jockey.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Jockey.com
            </a>
          </li>
        </ul>,
      ],
      insights: {
        title:
          "   How Acube technologies have helped tax data systems to provide the best experience to their clients",
        info: [
          <h5>
            <a
              className="text-primary ft-16 text-decoration-underline"
              href="https://acubetechnologies.in/Home"
              target="_blank"
              rel="noopener noreferrer"
            >
              Acube Technologies
            </a>{" "}
            has significantly contributed to enhancing Tax Data Systems' ability
            to offer top-notch experiences to its clients by leveraging
            cutting-edge technologies such as{" "}
            <a
              className="text-primary ft-16 text-decoration-underline"
              href="https://acubetechnologies.in/services/hire_aspnet_developer"
              target="_blank"
              rel="noopener noreferrer"
            >
              ASP.NET
            </a>{" "}
            , C#, MVC, and MSSQL.
          </h5>,
          <h5>
            Through the integration of these technologies, Tax Data Systems has
            been able to develop robust and scalable web applications tailored
            to the specific needs of its clientele. The utilization of ASP.NET
            ensures the creation of efficient and reliable platforms, while C#
            programming language guarantees high-performance and maintainable
            code. By adopting the MVC architecture, Tax Data Systems can
            organize and manage its codebase effectively, facilitating modular
            development and streamlined maintenance processes.
          </h5>,
          <h5>
            Moreover, Acube Technologies' proficiency in{" "}
            <a
              className="text-primary ft-16 text-decoration-underline"
              href="https://acubetechnologies.in/services/hire_AZURE_Cloud_developer"
              target="_blank"
              rel="noopener noreferrer"
            >
              MSSQL
            </a>{" "}
            database management has enabled Tax Data Systems to efficiently
            handle large volumes of data related to sales tax rates and
            jurisdictions. This ensures data integrity, security, and optimal
            performance, thereby enhancing the reliability and accuracy of Tax
            Data Systems' offerings. Through Acube's expertise and
            collaboration, Tax Data Systems continues to provide its clients
            with intuitive user experiences, real-time tax rate updates, and
            comprehensive reporting capabilities, solidifying its reputation as
            a leader in the sales tax solutions industry.
          </h5>,
        ],
      },
    },
    technologyList: {
      title: "Technologies that drives Tax Data System",
      image: portfolioImages.technology.tds,
      alt: "tds-tech",
    },
  },
  {
    pageName: "tynax",
    title: "TYNAX",
    content:
      "At the forefront of global high-tech patent trading, Tynax operates a cutting-edge exchange boasting hundreds of thousands of patents.",
    backgroundImage: portfolioImages.hero.tynax,
    infoSection: {
      image: portfolioImages.mockup.tynax,
      alt: "tynaxMockupImg",
      paragraphs: [
        <h5>
          At the forefront of global high-tech patent trading,{" "}
          <a
            className="text-primary ft-16 text-decoration-underline"
            href="https://tynax.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Tynax
          </a>{" "}
          operates a cutting-edge exchange boasting hundreds of thousands of
          patents. Nestled in the heart of Silicon Valley, California, Tynax
          harnesses the power of its specialized team and robust online platform
          to offer unparalleled sourcing capabilities for patent buyers
          worldwide.
        </h5>,
        <h5>
          Established in 2003 and headquartered in Delaware, Tynax invested
          years of research and development to craft a bespoke trading exchange
          tailored specifically to the dynamic needs of high-tech clients and
          patent holders. Leveraging its extensive database of patent holders
          and technologists, alongside an automated syndication system, Tynax
          orchestrates seamless connections between buyers and sellers,
          facilitating lucrative partnerships and innovation-driven
          collaborations.
        </h5>,
      ],
      insights: {
        title: "Acube Technologies software implementations with TYNAX",
        info: [
          <h5>
            <a
              className="text-primary ft-16 text-decoration-underline"
              href="https://acubetechnologies.in/Home"
              target="_blank"
              rel="noopener noreferrer"
            >
              Acube Technologies
            </a>{" "}
            has played a pivotal role in collaborating with TYNAX on innovative
            software implementations, particularly in web development,
            leveraging cutting-edge technologies to meet the demands of evolving
            times.
          </h5>,
          <h5>
            Our partnership with TYNAX has seen the integration of
            state-of-the-art solutions, ensuring that their web platforms remain
            at the forefront of efficiency and user experience. As technology
            evolves, we continuously expand our efforts to enhance and optimize
            the functionality of TYNAX's web infrastructure, aligning with their
            vision for excellence and adaptability in the dynamic landscape of
            patent trading. Together, we are committed to pushing the boundaries
            of possibility and delivering unparalleled value to TYNAX and its
            stakeholders.
          </h5>,
        ],
      },
    },
    technologyList: {
      title: "Technologies that drives Tynax",
      image: portfolioImages.technology.tynax,
      alt: "tynax",
    },
  },
  {
    pageName: "anatomie",
    title: "ANATOMIE STYLE",
    content:
      "Founded by the visionary duo Kate and Shawn Boyer, Anatomie stands as a beacon of innovation in the realm of designer fashion.",
    backgroundImage: portfolioImages.hero.anatomie,
    infoSection: {
      image: portfolioImages.mockup.anatomie,
      alt: "anatomieMockupImg",
      paragraphs: [
        <h5>
          Founded by the visionary duo{" "}
          <a
            className="text-primary ft-16 text-decoration-underline"
            href="https://anatomie.com/pages/about-us"
            target="_blank"
            rel="noopener noreferrer"
          >
            Kate and Shawn Boyer
          </a>
          ,{" "}
          <a
            className="text-primary ft-16 text-decoration-underline"
            href="https://anatomie.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Anatomie
          </a>{" "}
          stands as a beacon of innovation in the realm of designer fashion.
          Specifically tailored for the contemporary woman on the move, their
          collection seamlessly marries high-performance wear with modern
          designer travel attire and sportswear.
        </h5>,
        <h5>
          Kate, the creative force behind Anatomie, describes her creations as
          the epitome of sophistication and allure, perfectly reflecting the
          essence of the women who wear them. Drawing inspiration from
          prestigious European fashion houses, Anatomie's designs embody
          timeless class, elegance, and style, offering a distinctive blend of
          comfort and chic for the discerning traveler.
        </h5>,
      ],
      insights: {
        title: "How Acube Technologies helped ANATOMIE",
        info: [
          <h5>
            Implementing technology solutions for Anatomie involved harnessing
            the power of PHP, WordPress, WooCommerce, and Shopify to create a
            seamless online shopping experience.{" "}
            <a
              className="text-primary ft-16 text-decoration-underline"
              href="https://acubetechnologies.in/services/hire_WordPress_developer"
              target="_blank"
              rel="noopener noreferrer"
            >
              WordPress
            </a>{" "}
            formed the website's backbone, allowing easy content updates.
            WooCommerce, seamlessly integrated, powers the online store for
            showcasing products and secure transactions.
          </h5>,
          <h5>
            Shopify added flexibility and scalability, offering features for
            order management and analytics. Through{" "}
            <a
              className="text-primary ft-16 text-decoration-underline"
              href="https://acubetechnologies.in/services/hire_php_developer"
              target="_blank"
              rel="noopener noreferrer"
            >
              PHP
            </a>
            , developers customized the site's functionality for a cohesive
            brand experience. Together, these technologies empowered Anatomie to
            engage customers effectively, streamline operations, and drive sales
            growth in the competitive fashion market. These implementations have
            shown fantastic results for the fashion brand, in innovation and{" "}
            <a
              className="text-primary ft-16 text-decoration-underline"
              rel="noopener noreferrer"
              href="https://www.prnewswire.com/news-releases/anatomie-travels-to-new-heights-with-impressive-sales-and-continued-growth-301454096.html"
              target="_blank"
            >
              driving growth
            </a>{" "}
            for their business. Anatomie has also been recognized by{" "}
            <a
              className="text-primary ft-16 text-decoration-underline"
              href="https://www.forbes.com/sites/tanyaklich/2021/03/29/anatomie-wrinkle-free-luxury-travel-clothing-to-work-from-home-essentials-brand/?sh=419d2a402b6a"
              target="_blank"
              rel="noopener noreferrer"
            >
              Forbes
            </a>
            ,{" "}
            <a
              className="text-primary ft-16 text-decoration-underline"
              rel="noopener noreferrer"
              href="https://wwd.com/feature/anatomie-launch-full-mens-wear-collection-ath-leisure-1234883034/"
              target="_blank"
            >
              WWD
            </a>{" "}
            &{" "}
            <a
              className="text-primary ft-16 text-decoration-underline"
              rel="noopener noreferrer"
              href="https://moodiedavittreport.com/interview-fashion-brand-anatomie-and-pioneering-urban-air-port-get-set-for-joint-take-off/"
              target="_blank"
            >
              MoodieDavitt
            </a>{" "}
            for the innovative fashion changes that they have made along with
            the technology implemented by{" "}
            <a
              className="text-primary ft-16 text-decoration-underline"
              rel="noopener noreferrer"
              href="https://acubetechnologies.in/Home"
              target="_blank"
            >
              Acube technologies
            </a>
            .
          </h5>,
        ],
      },
    },
    technologyList: {
      title: "Technologies that drives Anatomie",
      image: portfolioImages.technology.anatomie,
      alt: "anatomie",
    },
  },
  {
    pageName: "vacsewcenter",
    title: "VACSEWCENTER",
    content:
      "Vacsewcenter takes great pride in its vast inventory, offering a diverse selection of machines, parts, and supplies, including elusive and hard-to-find items.",
    backgroundImage: portfolioImages.hero.vacsewcenter,
    infoSection: {
      image: portfolioImages.mockup.vacsewcenter,
      alt: "vacsewcenterMockupImg",
      paragraphs: [
        <h5>
          <a
            className="text-primary ft-16 text-decoration-underline"
            href="https://acubetechnologies.in/Home"
            target="_blank"
            rel="noopener noreferrer"
          >
            Vacsewcenter
          </a>{" "}
          takes great pride in its vast inventory, offering a diverse selection
          of machines, parts, and supplies, including elusive and hard-to-find
          items.
        </h5>,
        <h5>
          With{" "}
          <a
            className="text-primary ft-16 text-decoration-underline"
            rel="noopener noreferrer"
            href="https://www.flickr.com/people/vacsewcenter/"
            target="_blank"
          >
            Marty Dixon
          </a>{" "}
          at the helm, customers can rest assured that if it's not in their
          inventory, it's unlikely to be found elsewhere! The online store
          faithfully reflects the exceptional service and product quality that
          the Dixon family has upheld for over 50 years.
        </h5>,
        <h5>
          With a legacy deeply rooted in traditional values and a commitment to
          customer satisfaction, Vacsewcenter strives to deliver an unmatched
          shopping experience. Whether customers seek a specific sewing machine
          part or the latest vacuum model, the extensive selection and
          personalized service ensure that their needs are met with precision
          and care. Celebrating over five decades of excellence, Vacsewcenter
          continues to serve the community with integrity and dedication.
        </h5>,
      ],
      insights: {
        title:
          "How Acube technologies helped vacuum and sewing center expand their legacy store online",
        info: [
          <h5>
            Elevating Vacsewcenter's online presence, we deployed a cutting-edge
            technology solution featuring PHP, Laravel, and JSON for seamless
            website development. Our team orchestrated a dynamic and intuitive
            platform, powered by PHP and the robust Laravel framework, ensuring
            a captivating user experience. Leveraging JSON for efficient data
            exchange, we streamlined inventory management and enhanced website
            performance.
          </h5>,
          <h5>
            With our innovative approach,{" "}
            <a
              className="text-primary ft-16 text-decoration-underline"
              href="https://vacsewcenter.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Vacsewcenter
            </a>{" "}
            now offers customers an immersive browsing and shopping journey,
            solidifying its reputation as a premier destination for sewing and
            vacuum needs.{" "}
            <a
              className="text-primary ft-16 text-decoration-underline"
              href="https://acubetechnologies.in/Home"
              target="_blank"
              rel="noopener noreferrer"
            >
              Acube Technologies
            </a>{" "}
            tailored solution empowers Vacsewcenter to thrive in the digital
            landscape, delivering unparalleled service and products with style
            and sophistication.
          </h5>,
        ],
      },
    },
    technologyList: {
      title: "Technologies that drives Vacsewcenter",
      image: portfolioImages.technology.vacsewcenter,
      alt: "vacsewcenter",
    },
  },
  {
    pageName: "wbes",
    title: "WBES",
    content:
      "As West Boca Raton’s local provider of premium office space, WBES is optimally suited toward fulfilling the needs of our clients. With the resources of one of Boca’s largest property owners we are able to hire the most professional staff, offer the most luxurious furnishings and operate in a facility of the highest caliber.",
    backgroundImage: portfolioImages.hero.wbes,
    infoSection: {
      image: portfolioImages.mockup.wbes,
      alt: "wbesMockupImg",
      paragraphs: [
        <h5>
          WBES stands as the premier provider of premium office spaces in West
          Boca Raton, meticulously crafted to meet the diverse needs of our
          esteemed clients. Backed by the resources of one of Boca's largest
          property owners, we boast a team of highly professional staff, and
          luxurious furnishings, and operate within a facility of unparalleled
          excellence.
        </h5>,
        <h5>
          As an independent operator, we enjoy the freedom to make decisions
          that prioritize the comfort and satisfaction of our clients. Our
          flexible service policies are designed to create a welcoming
          atmosphere, ensuring that clients feel right at home.
        </h5>,
        <h5>
          Committed to fostering the growth of businesses and community outreach
          in Boca Raton, we proudly engage as active members of the Greater Boca
          Raton Chamber of Commerce. Join us in embracing the vibrant business
          community of West Boca Raton, where success and innovation thrive.
        </h5>,
      ],
      insights: {
        title:
          "How Acube technologies helped WBES to reach a widespread community of Office space users.",
        info: [
          <h5>
            <a
              className="text-primary ft-16 text-decoration-underline"
              href="https://acubetechnologies.in/Home"
              target="_blank"
              rel="noopener noreferrer"
            >
              Acube Technologies
            </a>{" "}
            played a pivotal role in helping WBES reach a widespread community
            of office space users by leveraging the power of .NET and AngularJS
            technologies.
          </h5>,
          <h5>
            With our expertise in .NET development, we created a robust and
            scalable platform for WBES, allowing them to efficiently manage
            their office space offerings and streamline user interactions. By
            integrating AngularJS, we enhanced the user experience, providing a
            seamless and intuitive interface for office space users to explore
            available options, book appointments, and access essential
            information about WBES facilities. Our innovative approach to
            technology implementation empowered WBES to effectively connect with
            a broader audience of office space users, facilitating ease of
            access and engagement.
          </h5>,
          <h5>
            Through our collaborative efforts, Acube Technologies and WBES have
            successfully expanded their reach within the office space community,
            offering a dynamic and user-centric platform that meets the diverse
            needs of modern businesses and professionals.
          </h5>,
        ],
      },
    },
    technologyList: {
      title: "Technologies that drives wbes",
      image: portfolioImages.technology.wbes,
      alt: "wbes",
    },
  },
  {
    pageName: "openn",
    title: "Openn, Australia",
    content:
      "Openn Negotiation is a transparent sales method that helps buyers and sellers find the true market price for a property through an online bidding platform.",
    backgroundImage: portfolioImages.hero.openn,
    infoSection: {
      image: portfolioImages.mockup.openn,
      alt: "opennMockupImg",
      paragraphs: [
        <h5>
          <a
            className="text-primary ft-16 text-decoration-underline"
            href="https://www.openn.com/en-au/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Openn
          </a>{" "}
          revolutionizes the property sales process by offering a transparent
          and efficient method for both buyers and sellers. By harnessing an
          online bidding platform, Openn enables buyers and sellers to discover
          the true market price of a property in real-time.
        </h5>,
        <h5>
          From the outset, qualified buyers can participate in the bidding
          process, with all bids visible, regardless of whether they meet the
          seller's reserve price. Sellers also benefit from the flexibility to
          approve buyers with favorable terms, enhancing the likelihood of
          maximizing the sale price. Openn fosters transparency and fosters a
          fair and competitive environment, ensuring that both buyers and
          sellers can achieve their desired outcomes with confidence.
        </h5>,
      ],
      insights: {
        title:
          "How Acube technologies helped Openn Negotiation revolutionize the property sales",
        info: [
          <h5>
            <a
              className="text-primary ft-16 text-decoration-underline"
              href="https://acubetechnologies.in/Home"
              target="_blank"
              rel="noopener noreferrer"
            >
              Acube Technologies
            </a>{" "}
            played a pivotal role in empowering Openn to revolutionize the
            property sales process by leveraging cutting-edge technologies such
            as React.JS, GoLang, Redux, AWS, and PostgreSQL. With our expertise
            in{" "}
            <a
              className="text-primary ft-16 text-decoration-underline"
              href="https://acubetechnologies.in/services/hire_reactjs_developer"
              target="_blank"
              rel="noopener noreferrer"
            >
              React.JS
            </a>
            , we crafted a dynamic and user-friendly frontend interface,
            providing a seamless experience for both buyers and sellers
            navigating the{" "}
            <a
              className="text-primary ft-16 text-decoration-underline"
              href="https://play.google.com/store/apps/details?id=au.com.openn&amp;hl=en_AU"
              target="_blank"
              rel="noopener noreferrer"
            >
              Openn platform
            </a>
            .
          </h5>,
          <h5>
            Utilizing{" "}
            <a
              className="text-primary ft-16 text-decoration-underline"
              rel="noopener noreferrer"
              href="https://acubetechnologies.in/services/hire_GoLang_developer"
              target="_blank"
            >
              GoLang
            </a>
            , we developed a robust and scalable backend infrastructure,
            enabling Openn Negotiation to handle large volumes of concurrent
            users and real-time bidding activities efficiently. By integrating
            Redux, we ensured state management consistency across the
            application, enhancing performance and reliability.
          </h5>,
          <h5>
            Our deployment of{" "}
            <a
              className="text-primary ft-16 text-decoration-underline"
              rel="noopener noreferrer"
              href="https://acubetechnologies.in/services/hire_AWS_Cloud_developer"
              target="_blank"
            >
              AWS (Amazon Web Services)
            </a>{" "}
            facilitated a secure and scalable hosting environment, ensuring
            optimal performance and data protection for all users. Additionally,
            leveraging PostgreSQL, we implemented a reliable and
            high-performance database solution, enabling Openn to store and
            manage vast amounts of transactional data securely.
          </h5>,
        ],
      },
    },
    technologyList: {
      title: "Technologies that drives openn",
      image: portfolioImages.technology.openn,
      alt: "openn",
    },
  },
  {
    pageName: "willship",
    title: "Willship International, Australia.",
    content:
      "Willship is the amalgamation of two specialized freight forwarders—one focused on international automotive freight, the other on general freight. The result is a team with over 100 years of industry experience and expertise in all elements of international shipping.",
    backgroundImage: portfolioImages.hero.willship,
    infoSection: {
      image: portfolioImages.mockup.willship,
      alt: "willshipMockupImg",
      paragraphs: [
        <h5>
          <a
            className="text-primary ft-16 text-decoration-underline"
            href="https://willship.com.au/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Willship
          </a>{" "}
          represents the union of two distinguished freight forwarders, each
          specializing in unique domains - one dedicated to international
          automotive freight and the other to general freight. This amalgamation
          brings together a seasoned team boasting over 100 years of collective
          industry experience and unparalleled expertise across all facets of
          international shipping.
        </h5>,
        <h5>
          With a wealth of knowledge and a deep understanding of the intricacies
          involved in freight forwarding, Willship stands as a trusted partner
          for clients seeking reliable and comprehensive shipping solutions.
        </h5>,
        <h5>
          To hear more about willship you can visit{" "}
          <a
            className="text-primary ft-16 text-decoration-underline"
            href="https://podcasts.apple.com/us/podcast/willship-international/id1555130238"
            target="_blank"
            rel="noopener noreferrer"
          >
            Apple podcast
          </a>{" "}
          &amp;{" "}
          <a
            className="text-primary ft-16 text-decoration-underline"
            href="https://medium.com/@internationalwillship"
            target="_blank"
            rel="noopener noreferrer"
          >
            Medium
          </a>
          .
        </h5>,
      ],
      insights: {
        title:
          "How Acube technologies helped Willship with an international shipping platform",
        info: [
          <h5>
            <a
              className="text-primary ft-16 text-decoration-underline"
              href="https://acubetechnologies.in/Home"
              target="_blank"
              rel="noopener noreferrer"
            >
              Acube Technologies
            </a>{" "}
            played a pivotal role in supporting Willship with the development of
            an advanced international shipping platform, leveraging a
            comprehensive array of cutting-edge technologies tailored to their
            specific requirements. With a focus on user experience and
            functionality, our team employed{" "}
            <a
              className="text-primary ft-16 text-decoration-underline"
              href="https://acubetechnologies.in/services/hire_WordPress_developer"
              target="_blank"
              rel="noopener noreferrer"
            >
              WordPress
            </a>{" "}
            as the foundation for the platform, providing a flexible and
            intuitive content management system. This allowed Willship to
            effortlessly manage website content and updates, ensuring relevance
            and accuracy for their users.
          </h5>,
          <h5>
            In conjunction with WordPress, our team utilized{" "}
            <a
              className="text-primary ft-16 text-decoration-underline"
              href="https://acubetechnologies.in/services/hire_php_developer"
              target="_blank"
              rel="noopener noreferrer"
            >
              PHP
            </a>{" "}
            to develop custom functionalities and features, enhancing the
            platform's performance and enabling seamless integration of various
            components. To ensure optimal performance and reliability, we
            deployed{" "}
            <a
              className="text-primary ft-16 text-decoration-underline"
              href="https://acubetechnologies.in/services/hire_AWS_Cloud_developer"
              target="_blank"
              rel="noopener noreferrer"
            >
              Amazon Web Services (AWS)
            </a>{" "}
            for secure and scalable hosting solutions. This strategic
            utilization of AWS enabled Willship to handle high traffic volumes
            efficiently, maintaining consistent uptime and reliability for their
            users.
          </h5>,
          <h5>
            In terms of design and user interface, Acube Technologies
            implemented HTML5 and responsive design principles to ensure a
            modern, accessible, and user-friendly experience across desktops,
            tablets, and mobile devices. This responsive design approach
            facilitated seamless navigation and interaction for users accessing
            the platform from diverse devices and screen sizes.
          </h5>,
          <h5>
            Behind the scenes, our team leveraged{" "}
            <a
              className="text-primary ft-16 text-decoration-underline"
              rel="noopener noreferrer"
              href="https://acubetechnologies.in/services/hire_AZURE_Cloud_developer"
              target="_blank"
            >
              Microsoft SQL Server (MSSQL)
            </a>{" "}
            as the backend database solution, providing a robust and scalable
            database management system for storing and managing shipping data
            securely. This ensured the integrity and reliability of critical
            shipping information, enabling Willship to operate with confidence
            and efficiency.
          </h5>,
          <h5>
            Through our collaborative efforts and expertise in WordPress, PHP,
            AWS, HTML5, responsive design, and MSSQL, Acube Technologies
            empowered Willship with a sophisticated international shipping
            platform. This platform not only streamlined operations but also
            enhanced customer experience, enabling Willship to expand its global
            reach and solidify its position in the competitive freight
            forwarding industry.
          </h5>,
        ],
      },
    },
    technologyList: {
      title: "Technologies that drives Willship",
      image: portfolioImages.technology.willship,
      alt: "willship",
    },
  },
];

export const portfolioUrlRouting = [
  {
    pathname: "/resources/portfolio/detail/rxnt",
    pageName: "rxnt",
  },
  {
    pathname: "/resources/portfolio/detail/frank",
    pageName: "frank",
  },
  {
    pathname: "/resources/portfolio/detail/svhs",
    pageName: "svhs",
  },
  {
    pathname: "/resources/portfolio/detail/tds",
    pageName: "tds",
  },
  {
    pathname: "/resources/portfolio/detail/tynax",
    pageName: "tynax",
  },
  {
    pathname: "/resources/portfolio/detail/anatomie",
    pageName: "anatomie",
  },
  {
    pathname: "/resources/portfolio/detail/vacsewcenter",
    pageName: "vacsewcenter",
  },
  {
    pathname: "/resources/portfolio/detail/wbes",
    pageName: "wbes",
  },
  {
    pathname: "/resources/portfolio/detail/openn",
    pageName: "openn",
  },
  {
    pathname: "/resources/portfolio/detail/willship",
    pageName: "willship",
  },
];
export const portfolioPages = [
  "rxnt",
  "frank",
  "svhs",
  "tds",
  "tynax",
  "anatomie",
  "vacsewcenter",
  "wbes",
  "openn",
  "willship",
];
